// src/components/AddItemCategoriaModal.js

import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const AddItemCategoriaModal = ({ show, handleClose, onCategoryAdded, API_BASE_URL }) => {
  const [categoryName, setCategoryName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      console.log(API_BASE_URL);
      const response = await fetch(`${API_BASE_URL}estoque/itemcategorias/novo/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ nome: categoryName }),
      });

      if (response.ok) {
        const newCategory = await response.json();
        onCategoryAdded(newCategory);
        setCategoryName("");
        handleClose();
      } else {
        const errorData = await response.json();
        setError(errorData.detail || "Erro ao cadastrar categoria.");
      }
    } catch (err) {
      console.error("Erro ao cadastrar categoria", err);
      setError("Ocorreu um erro inesperado.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Adicionar Nova Categoria</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Nome da Categoria</label>
            <input
                type="text"
                className="form-control"
                name="nome"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value.toUpperCase())}
                style={{ textTransform: "uppercase" }}
                required
                />
          </div>
          <Button variant="primary" type="submit">
            Salvar
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddItemCategoriaModal;